import { DEFAULT_PAGE_HEADER_HEIGHT } from 'bundles/composable-page-header/constants';

// Module-level singleton store for page header state.
// GlobalPageHeaderStateProvider lives deep inside DefaultHeader, making its React context
// inaccessible to sibling or ancestor components in other bundles. This store is the
// escape hatch, any component can read header state without being inside the provider tree.
// Written by GlobalPageHeaderStateProvider (layout metrics) and mobile drawer items via
// setPageHeaderInfoState.

type PageHeaderInfoStoreState = {
  height: number;
  scrollMovementOffset: number;
  shouldOffsetHeader: boolean;
  isMobileNavOpen: boolean;
  isMobileAccountMenuOpen: boolean;
};

type Listener = (state: PageHeaderInfoStoreState) => void;

let currentState: PageHeaderInfoStoreState = {
  height: DEFAULT_PAGE_HEADER_HEIGHT,
  scrollMovementOffset: 0,
  shouldOffsetHeader: false,
  isMobileNavOpen: false,
  isMobileAccountMenuOpen: false,
};

const listeners = new Set<Listener>();

export const setPageHeaderInfoState = (patch: Partial<PageHeaderInfoStoreState>) => {
  currentState = { ...currentState, ...patch };
  listeners.forEach((listener) => listener(currentState));
};

// Returns an unsubscribe function — pass directly to useSyncExternalStore or call in useEffect cleanup.
export const subscribeToPageHeaderInfoState = (listener: Listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getPageHeaderInfoState = () => currentState;
